import React from "react";
import { toast } from "react-toastify";
import { api } from "../../../services/api";
import EventoForm from "../../../components/evento/EventoForm";
import { MODO_CREAR } from "../../../domain/evento/schema";
import { usePlanesValidacion } from "../../../hooks/usePlanesValidacion";
import "./evento.css";

const CrearEvento = ({ onCreado }) => {
  const { validarCrearEvento, validando } = usePlanesValidacion();

  const crear = async (payload) => {
    const validacionPlan = await validarCrearEvento();
    if (!validacionPlan.valido) {
      toast.error(validacionPlan.mensaje, { autoClose: 6000 });
      return;
    }

    try {
      const response = await api.eventos.createEvento(payload);

      if (response.status !== "success") {
        toast.error(response.message || "No se pudo crear el evento.", {
          autoClose: 6000,
        });
        // el mensaje puede ser por límite de plan: se refrescan los límites
        await validarCrearEvento();
        return;
      }

      toast.success("Tu evento se creó correctamente.");
      // se refrescan los límites antes de salir de la pantalla
      await validarCrearEvento();
      onCreado(response.data.evento.id);
    } catch (error) {
      console.error("Error al crear evento:", error);
      toast.error("No se pudo conectar con el servidor.");
    }
  };

  return (
    <EventoForm
      modo={MODO_CREAR}
      onSubmit={crear}
      textoSubmit={validando ? "Validando límites..." : "Crear evento"}
      textoEnviando="Creando..."
      deshabilitado={validando}
    />
  );
};

export default CrearEvento;
